import { render, staticRenderFns } from "./TemplateContentLinkBadges.vue?vue&type=template&id=085c6692&scoped=true&"
import script from "./TemplateContentLinkBadges.vue?vue&type=script&lang=ts&"
export * from "./TemplateContentLinkBadges.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateContentLinkBadges.vue?vue&type=style&index=0&id=085c6692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c6692",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
